import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { Button } from '@raspberrypifoundation/design-system-react'
import './CollectionHeader.scss'

export const CollectionHeader = ({
  slug,
  subtitle,
  title,
  imageLeft = false,
  type = 'technology',
  showBackButton = false,
}) => {
  const { t } = useTranslation()

  const headerImg = slug || 'default'

  const collectionTypeClass =
    type === 'technology'
      ? 'c-collection-header--technology'
      : `c-collection-header--interest bg-${headerImg}`

  const imageLeftClass = imageLeft ? 'c-collection-header__image--left' : ''
  const imageTypeClass = `c-collection-header__image--${type}--${headerImg}`

  return (
    <header className={`c-collection-header ${collectionTypeClass}`}>
      <div
        className={`c-collection-header__wrapper  ${
          imageLeft ? 'c-collection-header__wrapper--left' : ''
        }`}
      >
        <div className={'c-collection-header__content'}>
          {showBackButton && (
            <Button
              className={'c-collection-header__button'}
              type="secondary"
              text={t('navigation.back')}
              href=""
              icon="arrow_back"
            />
          )}
          <div className="c-collection-header__text">
            <h1 className="c-collection-header__title">{title}</h1>
            <h2
              className="c-collection-header__subtitle"
              dangerouslySetInnerHTML={{ __html: subtitle }}
            />
          </div>
        </div>
        <div
          className={`c-collection-header__image--${type} ${imageLeftClass} ${imageTypeClass}`}
        />
      </div>
    </header>
  )
}

CollectionHeader.propTypes = {
  imageLeft: PropTypes.bool,
  showBackButton: PropTypes.bool,
  slug: PropTypes.string,
  type: PropTypes.string,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default CollectionHeader
